//#region dependecies
import React, { Component } from 'react';
import { CURRENCY, FORMAT_NUMBER, Modules, decodeText } from '../libs/utils/Const';
import { type } from 'jquery';
import Select from 'react-select';
//#endregion
const placeholderSearch = {
    '4': 'Artículo',
    '290': 'Recurso',
    '-18': 'Texto',
}
//#region global variables
const formatNumber = {
    separador: ',', // separador para los miles
    sepDecimal: '.', // separador para los decimales
    formatear: function (num) {
        num += '';
        let splitStr = num.split('.');
        let splitLeft = splitStr[0];
        let splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
        let regx = /(\d+)(\d{3})/;
        while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
        }
        return this.simbol + splitLeft + splitRight;
    },
    new: function (num, simbol) {
        this.simbol = simbol || '';
        if (typeof num == 'undefined') {
            num = 0;
        }
        if (isNaN(num)) {
            return num;
        }
        return this.formatear(Number(num).toFixed(2));
    },
};

const lMatType = [
    { Value: 'T', Tittle: 'Modelo' },
    { Value: 'S', Tittle: 'Ventas' },
    { Value: 'P', Tittle: 'Producción' },
    { Value: 'A', Tittle: 'Conjunto' }
];

const headersBody = [
    { title: "Tipo", value: true },
    { title: "N°", value: true },
    { title: "Descripción", value: true, style: { minWidth: 200 } },
    { title: "Cantidad", value: true },
    { title: "Nom. unidad de medida", value: true },
    { title: "Almacén", value: true },
    { title: "Método de emisión", value: true },
    { title: "Costo estándar de prod.", value: true },
    { title: "Costo estándar de prod. total", value: true },
    { title: "Lista de Precios", value: true },
    { title: "P. Unitario", value: true },
    { title: "Total", value: true },
    { title: "Comentarios", value: true },
    { title: "Cta. WIP", value: true },
    { title: "CANAL", value: Modules.CostCenter },
    { title: "SEDES", value: Modules.CostCenter },
    { title: "SUCURSAL", value: Modules.CostCenter },
    { title: "NEGOCIO", value: Modules.CostCenter },
    { title: "CECO", value: Modules.CostCenter },
    { title: "", value: true },
];
//#endregion

const customSelectStyles = {
    container: (base) => ({
        ...base,
        flex: 1,
        minWidth: 0
    }),
    control: (base, state) => ({
        ...base,
        height: 40,
        minHeight: 40,
        borderRadius: "0 4px 4px 0",
        borderColor: "#ced4da",
        backgroundColor: state.isDisabled ? "#e9ecef" : "#fff",
        boxShadow: "none",
        cursor: state.isDisabled ? "default" : "pointer",
        "&:hover": {
            borderColor: "#ced4da"
        }
    }),
    valueContainer: (base) => ({
        ...base,
        height: 40,
        padding: "0 12px"
    }),
    singleValue: (base) => ({
        ...base,
        color: "#495057",
        fontSize: "14px"
    }),
    input: (base) => ({
        ...base,
        color: "#495057",
        margin: 0,
        padding: 0
    }),
    indicatorsContainer: (base) => ({
        ...base,
        height: 40
    }),
    indicatorSeparator: () => ({
        display: "none"
    }),
    dropdownIndicator: (base) => ({
        ...base,
        color: "#8c959f"
    }),
    menu: (base) => ({
        ...base,
        zIndex: 9999
    }),
    menuPortal: (base) => ({
        ...base,
        zIndex: 9999
    }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isFocused ? "#f1f3f5" : "#fff",
        color: "#212529",
        cursor: "pointer"
    })
};

class ContentProductTree extends Component {
    constructor(props) {
        super(props);
        this.state = {
            OcrValues: [],
        };
    }

    //#region open Modals
    openItems = async (type = 'head') => {
        const { openItems } = this.props;
        openItems(type)
    }
    //#endregion

    //#region update field
    changeSearchItem = async (event) => {
        const { newOrderModel, refreshModel } = this.props;
        if (event.nativeEvent.data !== '') {
            newOrderModel.searchItemMaterial = event.nativeEvent.target.value.trim();
        }
        refreshModel(newOrderModel);
    }

    ChangeData = (event, key) => {
        const { newOrderModel, refreshModel, showAlert } = this.props
        const auxModel = { ...newOrderModel };
        let auxKey = null;
        let value = null;

        if (key === 'TreeCode') { auxModel.Desc = ""; }
        else if (key === 'Quantity') {
            if (isNaN(event.nativeEvent.target.value) || Number(event.nativeEvent.target.value) < 0) {
                return
            }
        }
        else if (key === 'Warehouse') {
            const items = auxModel.ProductTreeLines.slice()
            for (let index = 0; index < items.length; index++) {
                const itm = items[index];
                itm.Warehouse = event.nativeEvent.target.value;
            }
        }
        else if (key === 'TreeType') {
            const value = event.nativeEvent.target.value;
            if (auxModel.InvntItem === 'Y' && (value === 'A' || value === 'S')) {
                showAlert({ type: 'error', message: 'Solo una lista de materiales de producción puede definirse como artículo de inventario' })
                return
            }
        }
        if (key === 'WarehouseH') {
            auxKey = key;
            key = 'Warehouse';
            value = event?.value ?? event?.nativeEvent?.target?.value ?? null;
        }

        auxModel[key] = auxKey === 'WarehouseH' ? value || null : event.nativeEvent.target.value;
        refreshModel(auxModel)
    }

    ChangeListMaterials = (key, value, index) => {
        const { newOrderModel, refreshModel } = this.props
        let error = false
        let maxlength
        switch (key) {
            case 'Quantity':
                maxlength = 19;
                break;
            case 'PriceList':
                maxlength = 6
                break;
            case 'Price':
                maxlength = 19
                break;
            default:
                maxlength = 20
                break;
        }
        if (key === 'Quantity' || key === 'PriceList' || key === 'Price') {
            const regex = /^[0-9]*$/;
            if (!regex.test(value) || value.length > maxlength) {
                error = true
                return;
            }
            value = Number(value)
        }
        if (!error) {
            if (!newOrderModel.ProductTreeLines[index].IsNew) {
                newOrderModel.ProductTreeLines[index].IsEdit = true
            }
            newOrderModel.ProductTreeLines[index][key] = value

            refreshModel(newOrderModel)
        }
    }

    validateFieldNumber = (field = "", value = "", decimals = 2, target = null, minValue = 0) => {
        const { newOrderModel, refreshModel, showAlert } = this.props;
        const auxModel = { ...newOrderModel };
        let newValue = "";
        if (value && !isNaN(value)) { newValue = Number(Number(value).toFixed(decimals)); }
        if (newValue <= minValue && target) {
            target.focus();
            return showAlert({ type: "warning", message: `Ingrese un valor mayor a ${minValue}` });
        }
        auxModel[field] = newValue;
        refreshModel(auxModel)
    }

    DeleteItem = (index) => {
        const { newOrderModel, refreshModel } = this.props;
        newOrderModel.ProductTreeLines.splice(index, 1)
        refreshModel(newOrderModel)
    }
    //#endregion
    ChangeProject = event => {
        const { newOrderModel, refreshModel } = this.props;
        if (event && event.value !== undefined) {
            newOrderModel.Project = event.value;
        }
        else if (event && event.nativeEvent && event.nativeEvent.target) {
            newOrderModel.Project = event.nativeEvent.target.value;
        }
        else {
            newOrderModel.Project = '';
        }
        refreshModel(newOrderModel);
    };
    //#region render
    renderHeader = () => {
        const { action, listPrice, wareHouses, newOrderModel, editMode, projects } = this.props;
        const { OcrValues } = this.state;
        const projectOptions = projects ? projects.map(project => ({
            value: project.PrjCode,
            label: `${project.PrjCode} - ${project.PrjName}`
        })) : [];
        const whsOptions = wareHouses ? wareHouses?.filter(
            whs => whs.Inactive === 'N' // No sea inactivo
        )?.map(whs => ({
            value: whs.WhsCode,
            label: `${whs.WhsCode} - ${decodeText(whs.WhsName)}`
        })) : [];
        return (
            <div className="row">
                <div className="col-12 col-lg-6">
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">No. Producto</span>
                                <span className="d-inline d-xl-none">No Producto</span>
                            </span>
                        </div>
                        <input type="text" className="form-control"
                            id="txtNoProduct"
                            autoComplete="off"
                            disabled={action === 2}
                            value={newOrderModel.TreeCode}
                            onChange={(event) => this.ChangeData(event, 'TreeCode')}
                            onKeyPress={(ev) => {
                                if (ev.key === 'Enter') {
                                    this.openItems('head');
                                }
                            }}
                        />
                        {action === 1 && (
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text">
                                <i className="fa fa-list" aria-hidden="true"
                                    onClick={() => this.openItems('head')} />
                            </button>
                        )}
                    </div>

                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Descripción</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtDescr"
                            disabled={true}
                            value={newOrderModel.Desc}
                            onChange={(event) => this.ChangeData(event, 'Desc')} />
                    </div>

                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Tipo LMat</span>
                        </div>
                        <select
                            className="form-control"
                            disabled={action === 2 && !editMode}
                            value={newOrderModel.TreeType}
                            onChange={(event) => this.ChangeData(event, 'TreeType')}
                        >
                            {lMatType.map((type, index) => {
                                return (
                                    <option key={index} value={type.Value}>{type.Tittle}</option>
                                )
                            })}
                        </select>
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">Costo estandar de producción</span>
                                <span className="d-inline d-xl-none">Costo Estándar</span>
                            </span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtProdCost"
                            disabled={true}
                        />
                    </div>

                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">Tamaño producc.prom. planif.</span>
                                <span className="d-inline d-xl-none">Tamaño Producción</span>
                            </span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtProdSize"
                            disabled={action === 2 && !editMode}
                            value={newOrderModel.PlAvgSize}
                            onChange={(event) => this.ChangeData(event, 'PlAvgSize')}
                            onBlur={({ target }) => this.validateFieldNumber('PlAvgSize', newOrderModel.PlAvgSize, 4, target)} />
                    </div>
                </div>

                {/*Segunda columna*/}
                <div className="col-12 col-lg-6">
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">X Cantidad</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtQuantity"
                            disabled={action === 2 && !editMode}
                            value={newOrderModel.Quantity}
                            onChange={(event) => this.ChangeData(event, 'Quantity')}
                            onBlur={() => this.validateFieldNumber('Quantity', newOrderModel.Quantity, 3)} />
                    </div>
                    {newOrderModel.TreeType === 'P' &&
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Almacén</span>
                            </div>

                            {(
                                <Select
                                    options={whsOptions}
                                    value={whsOptions?.find(opt => opt.value === newOrderModel?.Warehouse) || null}
                                    onChange={(event) => this.ChangeData(event, 'WarehouseH')}
                                    placeholder="Escribe para buscar un almacén"
                                    isDisabled={action === 2 && !editMode}
                                    isSearchable={true}
                                    isClearable={true}
                                    menuPortalTarget={document.body}
                                    noOptionsMessage={() => 'No se encontraron coincidencias'}
                                    styles={{
                                        container: (base) => ({ ...base, flex: 1 }),
                                        control: (base) => ({ ...base, height: 40, minHeight: 40, minWidth: 300, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                        menu: (base) => ({ ...base, zIndex: 9999 }),
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                                        input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                        singleValue: (base) => ({ ...base, color: "#000" })
                                    }} />
                                /*
                                <select
                                    className="form-control"
                                    disabled={action === 2 && !editMode}
                                    value={newOrderModel.Warehouse}
                                    onChange={(event) => this.ChangeData(event, 'Warehouse')}
                                >
                                    {wareHouses?.map((key, index) => {
                                        return (
                                            <option key={key.WhsCode} value={key.WhsCode}>{key.WhsName}</option>
                                        )
                                    })}
                                </select>
                                */
                            )}
                        </div>}

                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">Lista de precios</span>
                                <span className="d-inline d-xl-none">Lista precios</span>
                            </span>
                        </div>

                        {(
                            <select
                                className="form-control"
                                disabled={action === 2 && !editMode}
                                value={newOrderModel.PriceList}
                                onChange={(event) => this.ChangeData(event, 'PriceList')}
                            >
                                {listPrice?.map((key, index) => {
                                    return (
                                        <option key={key.ListNum} value={key.ListNum}>{key.ListName}</option>
                                    )
                                })}
                            </select>
                        )}
                    </div>



                    {/* <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Norm. reparto</span>
                        </div>
                        <select
                            className="form-control"
                            disabled={action === 2 && !editMode}
                        >
                            {OcrValues.map((index) => {
                                return (
                                    <option key={index}></option>
                                )
                            })}
                        </select>
                    </div> */}
                    {/* <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Proyecto</span>
                        </div>
                        <Select
                            options={projectOptions}
                            value={projectOptions.find(opt => opt.value === newOrderModel.Project) || null}
                            onChange={this.ChangeProject}
                            placeholder="Escribe para buscar un proyecto"
                            isDisabled={action === 2 && !editMode}
                            isSearchable={true}
                            isClearable={true}
                            menuPortalTarget={document.body}
                            noOptionsMessage={() => 'No se encontraron coincidencias'}
                            styles={{
                                container: (base) => ({ ...base, flex: 1 }),
                                control: (base) => ({ ...base, height: 40, minHeight: 40, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                                input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                singleValue: (base) => ({ ...base, color: "#000" })
                            }}
                        /> */}
                    {/* <input
                            type="text"
                            className="form-control"
                            id="txtProyect"
                            disabled={action === 2 && !editMode}
                            value={newOrderModel.Project}
                            onChange={(event) => this.ChangeData(event, 'Project')}
                        /> */}
                    {/* </div> */}
                </div>
            </div>
        );
    }

    ChangeWareHouse = (event, index) => {
        const { newOrderModel, refreshModel, showAlert, wareHouses = [] } = this.props;
        let value = null
        if (event && event.value !== undefined) {
            value = event.value;
        }
        else if (event && event.nativeEvent && event.nativeEvent.target) {
            value = event.nativeEvent.target.value;
        }
        else {
            value = '';
        }
        newOrderModel.ProductTreeLines[index]['Warehouse'] = value || null;
        //#region DIMENSIONS
        const { ItemType = 0, ItemCode = '', ItemName = '' } = newOrderModel?.ProductTreeLines?.[index] ?? {};
        if (Modules.CostCenter && (Number(ItemType ?? 4) === 4 || Number(ItemType ?? 4) === 290) && ItemCode) { // Para artículos y recursos
            let warehouse = wareHouses?.find(whs => whs.WhsCode === value) ?? {};
            const typeL = Number(ItemType ?? 4) === 4 ? 'artículo' : 'recurso';
            if (value) { // Existe almacén
                newOrderModel.ProductTreeLines[index].OcrCode2 = warehouse?.U_LLG_DIME2 || ''; // Determinado desde el almacén
                newOrderModel.ProductTreeLines[index].OcrCode3 = warehouse?.U_LLG_DIME3 || ''; // Determinado desde el almacén

                newOrderModel.ProductTreeLines[index].Dimension2 = newOrderModel.ProductTreeLines[index].OcrCode2 ? true : false;
                newOrderModel.ProductTreeLines[index].Dimension3 = newOrderModel.ProductTreeLines[index].OcrCode3 ? true : false;
                showAlert({ type: 'warning', message: `El valor de "SEDES" y el valor de "SUCURSAL" del ${typeL} ${ItemCode || ItemName} ha sido ajustado al cambiar de almacén`, timeOut: 5000 });
            } else {
                newOrderModel.ProductTreeLines[index].OcrCode2 = null;
                newOrderModel.ProductTreeLines[index].OcrCode3 = null;
            }
        }
        //#endregion DIMENSIONS
        refreshModel(newOrderModel);
    };

    renderBody = () => {
        const { newOrderModel, wareHouses, listPrice, editMode, action, openCentroCoste } = this.props
        const whsOptions = wareHouses ? wareHouses.map(whs => ({
            value: whs.WhsCode,
            label: `${whs.WhsCode} - ${decodeText(whs.WhsName)}`
        })) : [];
        return (
            <div style={{ marginBottom: 30 }}>
                <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <a
                            className={"nav-item nav-link font-weight-bold text-secondary"}
                            id="nav-profile-tab-Contenido-D"
                            data-toggle="tab"
                            href="#dataContenidoDocument"
                            role="tab"
                            aria-controls="dataContenidoDocument"
                            aria-selected="true">
                            Contenido
                        </a>
                    </div>
                </nav>

                <div className="tab-content" style={{ paddingTop: 5, textAlign: 'left' }}>
                    {/* CONTENIDO */}
                    <div
                        className="w-100 table-scroll tab-pane fade"
                        id="dataContenidoDocument"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-Contenido"
                        style={{ maxHeight: 2000, maxWidth: 3000, paddingTop: 5 }}
                    >
                        <table
                            id="dataTableDocuments"
                            className="display"
                            style={{ width: '100%', marginBottom: 40, marginRight: -30000 }}>
                            <thead className="table-header-yellow">
                                <tr style={{ textAlign: "center" }}>
                                    <td className="sticky-column sticky-header" style={{ width: 40, background: "#d2ab24" }}>
                                        #
                                    </td>
                                    {headersBody.map((header, index) => {
                                        if (header.value) {
                                            return (
                                                <td key={index} className="sticky-header" style={{ ...header.style, background: "#d2ab24" }}>
                                                    {header.title}
                                                </td>
                                            );
                                        }
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {newOrderModel.ProductTreeLines.map((item, index) => {
                                    if (Number(item?.ItemType ?? 4) === -18) {
                                        return (
                                            <tr
                                                style={{
                                                    maxHeight: 10,
                                                    paddingTop: 8,
                                                    paddingBottom: 8,
                                                }}
                                                data-toggle={'tooltip'}
                                            >
                                                <td className="sticky-column" style={{ background: "#FFF", widht: 150 }}>
                                                    {index + 1}
                                                </td>
                                                {/* Tipo */}
                                                <td style={{ minWidth: '150px' }} >
                                                    <select
                                                        disabled={true}
                                                        id='ItemType'
                                                        className="form-control"
                                                        value={item.ItemType}
                                                    // onChange={(event) => this.ChangeListMaterials('ItemType', event.nativeEvent.target.value, index)}
                                                    >
                                                        <option value='4'>Artículo</option>
                                                        <option value='290'>Recurso</option>
                                                        <option value='-18'>Texto</option>
                                                    </select>
                                                </td>
                                                <td colSpan={(headersBody.length - 2) || 1}>
                                                    <input
                                                        style={{ minWidth: '100px' }}
                                                        disabled={action === 2 && !editMode}
                                                        value={item.LineText}
                                                        id='LineText'
                                                        className="form-control"
                                                        type="text"
                                                        onChange={(event) => this.ChangeListMaterials('LineText', event.nativeEvent.target.value, index)}
                                                    />
                                                </td>
                                                <td
                                                    className="sticky-columns"
                                                    style={{ backgroundColor: '#FFF', textAlign: 'center' }}>
                                                    {/*Eliminar*/}
                                                    {!(action === 2 && !editMode) && (
                                                        <button
                                                            type="button"
                                                            style={{
                                                                backgroundColor: 'transparent',
                                                                padding: 5,
                                                                color: '#c42222',
                                                            }}
                                                            className="btn"
                                                            onClick={() => this.DeleteItem(index)}>
                                                            <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                        </button>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    } else {
                                        return (
                                            <tr style={{
                                                maxHeight: 10,
                                                paddingTop: 8,
                                                paddingBottom: 8,
                                                // backgroundColor: item.LineStatus ? 'rgb(210,210,210)' : (newOrderModel.ObjType === '18' && view === 'invoiceAuthorization') ? (!item.BaseLine && item.BaseLine !== 0) ? '#FFD19B' : 'transparent' : 'transparent'
                                            }}
                                                data-toggle={'tooltip'}

                                            >
                                                <td className="sticky-column" style={{ background: "#FFF", widht: 150 }}>
                                                    {index + 1}
                                                </td>
                                                {/* Tipo */}
                                                <td style={{ minWidth: '150px' }} >
                                                    <select
                                                        disabled={true}
                                                        id='ItemType'
                                                        className="form-control"
                                                        value={item.ItemType}
                                                    // onChange={(event) => this.ChangeListMaterials('ItemType', event.nativeEvent.target.value, index)}
                                                    >
                                                        <option value='4'>Artículo</option>
                                                        <option value='290'>Recurso</option>
                                                        <option value='-18'>Texto</option>
                                                    </select>
                                                </td>
                                                {/*Artículos*/}
                                                <td className="overflow-visible"
                                                    style={{ backgroundColor: item.LineStatus ? 'rgb(210,210,210)' : '#FFF' }}>
                                                    {item.ItemCode}
                                                </td>
                                                {/* Descripción */}
                                                <td className="overflow-visible"
                                                    style={{ backgroundColor: item.LineStatus ? 'rgb(210,210,210)' : '#FFF' }}>
                                                    {item.ItemName}
                                                </td>
                                                {/* Cantidad */}
                                                <td>
                                                    <input
                                                        style={{ minWidth: '100px' }}
                                                        disabled={action === 2 && !editMode}
                                                        value={item.Quantity}
                                                        id='ItemQuantity'
                                                        className="form-control"
                                                        type="text"
                                                        onChange={(event) => this.ChangeListMaterials('Quantity', event.nativeEvent.target.value, index)}
                                                    />
                                                </td>
                                                {/* Nom. unidad de medida */}
                                                <td style={{ textAlign: 'center' }}>
                                                    <label
                                                        className="font-weight-bold"

                                                        id='ItemUnit'>{item.InventoryUOM}</label>
                                                </td>
                                                {/* Almacén */}
                                                <td>
                                                    <Select
                                                        options={whsOptions}
                                                        value={whsOptions?.find(opt => opt.value === item.Warehouse) || null}
                                                        onChange={(e) => this.ChangeWareHouse(e, index)}
                                                        placeholder="Escribe para buscar un almacén"
                                                        isDisabled={action === 2 && !editMode}
                                                        isSearchable={true}
                                                        isClearable={true}
                                                        menuPortalTarget={document.body}
                                                        noOptionsMessage={() => 'No se encontraron coincidencias'}
                                                        styles={{
                                                            container: (base) => ({ ...base, flex: 1 }),
                                                            control: (base) => ({ ...base, height: 40, minHeight: 40, minWidth: action === 2 && !editMode ? 575 : 610, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                                            menu: (base) => ({ ...base, zIndex: 9999 }),
                                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                            valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                                                            input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                                            singleValue: (base) => ({ ...base, color: "#000" })
                                                        }} />
                                                    {/* <select
                                                        style={{ minWidth: '250px' }}
                                                        disabled={action === 2 && !editMode}
                                                        id='ItemWHS'
                                                        className="form-control"
                                                        value={item.Warehouse}
                                                        onChange={(event) => this.ChangeListMaterials('Warehouse', event.nativeEvent.target.value, index)}>
                                                        {wareHouses?.map((wareHouse, index) => {
                                                            return (
                                                                <option key={'WareHouseBody' + index} value={wareHouse.WhsCode}>{wareHouse.WhsName}</option>
                                                            )
                                                        })}
                                                    </select> */}
                                                </td>
                                                {/* Método de emisión */}
                                                <td>
                                                    <Select
                                                        id='ItemEmision'
                                                        className="p-0 border-0"
                                                        classNamePrefix="react-select"
                                                        options={[
                                                            { value: 'M', label: 'Manual' },
                                                            { value: 'B', label: 'Notificación' }
                                                        ]}
                                                        value={[
                                                            { value: 'M', label: 'Manual' },
                                                            { value: 'B', label: 'Notificación' }
                                                        ].find(opt => opt.value === item.IssueMethod) || null}
                                                        onChange={(selected) => this.ChangeListMaterials('IssueMethod', selected ? selected.value : '', index)}
                                                        placeholder="Seleccionar"
                                                        isDisabled={action === 2 && !editMode}
                                                        isSearchable={true}
                                                        isClearable={false}
                                                        menuPortalTarget={document.body}
                                                        noOptionsMessage={() => 'No se encontraron coincidencias'}
                                                        styles={customSelectStyles}
                                                    />
                                                </td>
                                                {/* Costo estándar de prod. */}
                                                <td style={{ textAlign: 'center' }}>
                                                    <label
                                                        className="font-weight-bold"
                                                        id='StdCost1'>{`${item?.Currency ?? 'SOL '} ${item?.StdCost1 ?? 0}`}</label>
                                                </td>
                                                {/* Costo estándar de prod. total */}
                                                <td style={{ textAlign: 'center' }}>
                                                    <label
                                                        className="font-weight-bold"
                                                        id='StsCost1Qty'>{`${item?.Currency ?? 'SOL '} ${formatNumber.new((item.StdCost1 ?? 0) * (item.Quantity ?? 0))}`}</label>
                                                </td>
                                                {/* Lista de Precios */}
                                                {Number(item?.ItemType ?? 4) == 4 ?
                                                    <td className="sticky-column">
                                                        <select
                                                            style={{ minWidth: '200px' }}
                                                            disabled={action === 2 && !editMode}
                                                            id='ItemPriceList'
                                                            className="form-control"
                                                            value={item.PriceList}
                                                            onChange={(event) => this.ChangeListMaterials('PriceList', event.nativeEvent.target.value, index)}>
                                                            {listPrice.map((list, index) => {
                                                                return (
                                                                    <option key={'PriceListBody' + index} value={list.PriceList}>{list.ListName}</option>
                                                                )
                                                            })}
                                                        </select>
                                                    </td> : <td></td>
                                                }
                                                {/* P. Unitario */}
                                                <td>
                                                    <input
                                                        disabled={action === 2 && !editMode}
                                                        value={item.Price}
                                                        id='ItemUnitPrice'
                                                        className="form-control"
                                                        type="text"
                                                        onChange={(event) => this.ChangeListMaterials('Price', event.nativeEvent.target.value, index)}
                                                    />
                                                </td>
                                                {/* Total */}
                                                <td style={{ textAlign: 'right' }}>
                                                    <label
                                                        className="font-weight-bold"
                                                        disabled={action === 2 && !editMode}
                                                        id='ItemTotal'> {item.Currency} {formatNumber.new((item.Quantity || 0) * (item.Price || 0))}</label>
                                                </td>
                                                {/* Comentarios */}
                                                <td>
                                                    <input
                                                        style={{ minWidth: '200px' }}
                                                        disabled={action === 2 && !editMode}
                                                        value={item.Comment || ''}
                                                        id='ItemComments'
                                                        className="form-control"
                                                        type="text"
                                                        onChange={(event) => this.ChangeListMaterials('Comment', event.nativeEvent.target.value, index)}
                                                    />
                                                </td>
                                                <td
                                                    className="sticky-columns">
                                                </td>
                                                {Modules.CostCenter && <>
                                                    <td style={{ minWidth: 150 }}>
                                                        <div className="input-group">
                                                            <input
                                                                className="form-control"
                                                                disabled
                                                                readOnly
                                                                value={item?.OcrCode || ""} />

                                                            {((action === 1 || (action === 2 && editMode)) && !item?.Dimension1) && (
                                                                <div className="input-group-append" >
                                                                    <button
                                                                        type="button"
                                                                        style={{
                                                                            backgroundColor: 'transparent',
                                                                            color: '#EABF28',
                                                                            paddingTop: 2,
                                                                            paddingBottom: 2,
                                                                            border: "1px solid #ced4da"
                                                                        }}
                                                                        className="btn btn-outline-secondary"
                                                                        onClick={() => openCentroCoste(index, 1)}>
                                                                        <i className="fa fa-list" aria-hidden="true" />
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td style={{ minWidth: 150 }}>
                                                        <div className="input-group">
                                                            <input
                                                                className="form-control"
                                                                disabled
                                                                readOnly
                                                                value={item?.OcrCode2 || ""} />

                                                            {((action === 1 || (action === 2 && editMode)) && !item?.Dimension2) && (
                                                                <div className="input-group-append" >
                                                                    <button
                                                                        type="button"
                                                                        style={{
                                                                            backgroundColor: 'transparent',
                                                                            color: '#EABF28',
                                                                            paddingTop: 2,
                                                                            paddingBottom: 2,
                                                                            border: "1px solid #ced4da"
                                                                        }}
                                                                        className="btn btn-outline-secondary"
                                                                        onClick={() => openCentroCoste(index, 2)}>
                                                                        <i className="fa fa-list" aria-hidden="true" />
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td style={{ minWidth: 150 }}>
                                                        <div className="input-group">
                                                            <input
                                                                className="form-control"
                                                                disabled
                                                                readOnly
                                                                value={item?.OcrCode3 || ""} />

                                                            {((action === 1 || (action === 2 && editMode)) && !item?.Dimension3) && (
                                                                <div className="input-group-append" >
                                                                    <button
                                                                        type="button"
                                                                        style={{
                                                                            backgroundColor: 'transparent',
                                                                            color: '#EABF28',
                                                                            paddingTop: 2,
                                                                            paddingBottom: 2,
                                                                            border: "1px solid #ced4da"
                                                                        }}
                                                                        className="btn btn-outline-secondary"
                                                                        onClick={() => openCentroCoste(index, 3)}>
                                                                        <i className="fa fa-list" aria-hidden="true" />
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td style={{ minWidth: 150 }}>
                                                        <div className="input-group">
                                                            <input
                                                                className="form-control"
                                                                disabled
                                                                readOnly
                                                                value={item?.OcrCode4 || ""} />

                                                            {((action === 1 || (action === 2 && editMode)) && !item?.Dimension4) && (
                                                                <div className="input-group-append" >
                                                                    <button
                                                                        type="button"
                                                                        style={{
                                                                            backgroundColor: 'transparent',
                                                                            color: '#EABF28',
                                                                            paddingTop: 2,
                                                                            paddingBottom: 2,
                                                                            border: "1px solid #ced4da"
                                                                        }}
                                                                        className="btn btn-outline-secondary"
                                                                        onClick={() => openCentroCoste(index, 4)}>
                                                                        <i className="fa fa-list" aria-hidden="true" />
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td style={{ minWidth: 150 }}>
                                                        <div className="input-group">
                                                            <input
                                                                className="form-control"
                                                                disabled
                                                                readOnly
                                                                value={item?.OcrCode5 || ""} />

                                                            {((action === 1 || (action === 2 && editMode)) && !item?.Dimension5) && (
                                                                <div className="input-group-append" >
                                                                    <button
                                                                        type="button"
                                                                        style={{
                                                                            backgroundColor: 'transparent',
                                                                            color: '#EABF28',
                                                                            paddingTop: 2,
                                                                            paddingBottom: 2,
                                                                            border: "1px solid #ced4da"
                                                                        }}
                                                                        className="btn btn-outline-secondary"
                                                                        onClick={() => openCentroCoste(index, 5)}>
                                                                        <i className="fa fa-list" aria-hidden="true" />
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td>
                                                </>}
                                                <td
                                                    className="sticky-columns"
                                                    style={{ backgroundColor: '#FFF', textAlign: 'center' }}>
                                                    {/*Eliminar*/}
                                                    {!(action === 2 && !editMode) && (
                                                        <button
                                                            type="button"
                                                            style={{
                                                                backgroundColor: 'transparent',
                                                                padding: 5,
                                                                color: '#c42222',
                                                            }}
                                                            className="btn"
                                                            onClick={() => this.DeleteItem(index)}>
                                                            <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                        </button>
                                                    )}
                                                </td>
                                            </tr>
                                        )
                                    }
                                })
                                }
                                <tr style={{
                                    maxHeight: 10,
                                    paddingTop: 8,
                                    paddingBottom: 8,
                                }}>
                                    <td />
                                    <td className="sticky-column"
                                        style={{ backgroundColor: '#FFF', textAlign: 'center' }}>
                                        {(action === 1 || editMode) && newOrderModel.Desc && (
                                            <div>

                                                <select
                                                    id='ItemTypeSearch'
                                                    className="form-control"
                                                    value={newOrderModel?.ItemTypeSearch ?? '4'}
                                                    onChange={(event) => this.ChangeData(event, 'ItemTypeSearch')}
                                                >
                                                    <option value='4'>Artículo</option>
                                                    <option value='290'>Recurso</option>
                                                    <option value='-18'>Texto</option>
                                                </select>

                                                <input
                                                    id='InputSearchItmsMaterial'
                                                    type=" text"
                                                    placeholder={placeholderSearch[newOrderModel?.ItemTypeSearch ?? '4']}
                                                    className=" form-control btn-outline-secondary"
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        color: '#000',
                                                        paddingTop: 1,
                                                        paddingBottom: 2,
                                                        minWidth: '130px',
                                                    }}
                                                    onKeyPress={(ev) => {
                                                        if (ev.key === 'Enter') {
                                                            this.openItems('lines');
                                                        }
                                                    }}
                                                    value={newOrderModel.searchItemMaterial || ''}
                                                    onChange={event => this.changeSearchItem(event)}
                                                />
                                                <button
                                                    type="button"
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        padding: 5,
                                                        color: 'green',
                                                        paddingTop: 2,
                                                        paddingBottom: 2,
                                                    }}
                                                    className="btn"
                                                    onClick={() => this.openItems('lines')}>
                                                    <i className="fa fa-plus-circle" aria-hidden="true" size="10" />
                                                </button>
                                            </div>
                                        )}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }

    renderFooter = () => {
        const { action } = this.props;
        return (
            <div className="row">
                <div className="d-none d-lg-flex col-6" />
                <div className="col-12 col-lg-6">
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Precio de producto</span>
                        </div>
                        <input
                            style={{ textAlign: 'right' }}
                            type="text"
                            className="form-control"
                            id="txtPrice"
                            disabled={action === 2}
                            value={FORMAT_NUMBER.new(0)}
                        />
                        <div className="input-group-append">
                            <span className="input-group-text"> {CURRENCY} </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { render } = this.props;
        let content = ''
        switch (render) {
            case 'header':
                content = this.renderHeader();
                break;
            case 'body':
                content = this.renderBody();
                break;
            case 'footer':
                content = this.renderFooter();
                break;
            default:
                content = '';
        }

        return (
            <div>
                {content}
            </div>
        );
    }
    //#endregion
}

export default ContentProductTree;